export function getSelectComOptionByOrgList(orgList, currentCId, rootId) {
  if (!Array.isArray(orgList)) return [];

  const companies = orgList.filter(
    (item) =>
      item.orgType === "COMPANY" && item.nodeStatus === "editable",
  );

  const isCurrentOrDescendant = (item) => {
    const levelIds = String(item.level ?? "").split("/");
    return item.value === currentCId || levelIds.includes(currentCId);
  };

  // Root node: return all companies.
  if (currentCId === rootId) {
    return companies.map((item) => ({
      label: item.label,
      value: item.value,
    }));
  }

  // Company node: return itself and descendant companies.
  const selfCompany = companies.find((item) => item.value === currentCId);
  if (selfCompany) {
    return companies
      .filter(isCurrentOrDescendant)
      .map((item) => ({
        label: item.label,
        value: item.value,
      }));
  }

  // Category node: return descendant companies.
  return companies
    .filter((item) => {
      const levelIds = String(item.level ?? "").split("/");
      return levelIds.includes(currentCId);
    })
    .map((item) => ({
      label: item.label,
      value: item.value,
    }));
}

export function getSelectComOptionByCompanyList(companyList, currentId, role) {
  if (!Array.isArray(companyList)) return [];

  const companies = companyList.filter(
    (item) => item.nodeStatus === "editable",
  );

  const filteredCompanies = currentId
    ? companies.filter((item) => {
        const levelIds = String(item.level ?? "").split("/");
        return item.id === currentId || levelIds.includes(currentId);
      })
    : companies;

  const optionCompanies =
    filteredCompanies.length === 0 && role === "super_admin"
      ? companies
      : filteredCompanies;

  return optionCompanies.map((item) => ({
    label: item.companyName,
    value: item.id,
  }));
}
